import {
  faBallotCheck,
  faBug,
  faCheckToSlot,
  faCopy,
  faHammer,
  faHeartbeat,
  faPen,
  faPlusCircle,
  faRectangleHistoryCircleUser,
  faRightLeft,
  faSquareSlidersVertical,
  faUpload,
} from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'

export const taskTypes = [
  'bug',
  'health_check',
  'improvement',
  'new',
  'new_existing',
  'new_existing_without_items',
] as const

export type TaskType = typeof taskTypes

export const subTaskTypes = [
  'build',
  'change_request',
  'design',
  'link',
  'qc_external',
  'qc_final',
  'qc_internal',
] as const

export type SubTaskType = typeof subTaskTypes

export const taskTypeSettings = {
  bug: {
    icon: faBug,
    label: 'Bug',
  },
  build: {
    icon: faHammer,
    label: 'Build Template',
  },
  change_request: {
    icon: faRightLeft,
    label: 'Change Request',
  },
  design: {
    icon: faUpload,
    label: 'Upload Design File',
  },
  health_check: {
    icon: faHeartbeat,
    label: 'Health Check',
  },
  improvement: {
    icon: faPen,
    label: 'Improvement',
  },
  link: {
    Icon: faSquareSlidersVertical,
    label: 'Template Linking',
  },
  new: {
    icon: faPlusCircle,
    label: 'New',
  },
  new_existing: {
    icon: faCopy,
    label: 'New from Existing',
  },
  new_existing_without_items: {
    icon: faCopy,
    label: 'New from Existing Witout Items',
  },
  qc_external: {
    icon: faRectangleHistoryCircleUser,
    conditional: true,
    label: 'Template QC (Client)',
  },
  qc_final: {
    icon: faCheckToSlot,
    label: 'Final QC',
  },
  qc_internal: {
    icon: faBallotCheck,
    conditional: true,
    label: 'Template QC (Internal)',
  },
}

export const getTaskTypeSetting = (taskType: SubTaskType | TaskType, settingKey: 'conditional' | 'label') => {
  const value = digObject(taskTypeSettings, `${taskType}.${settingKey}`)
  return value
}
